import React from 'react';
import { getStatusColors, formatCurrency } from '@/lib/fmUtils';
import ProgressBarWithLabel from './ProgressBarWithLabel';

/**
 * KpiCard - Individual KPI display card with status-colored background.
 * Props:
 *   kpi      - { id, label, value, target, progress_pct, format }
 *   status   - "RED" | "YELLOW" | "GREEN" | null
 *   onClick  - handler for drill-down tap
 */
export default function KpiCard({ kpi, status, onClick }) {
  const { label, value, target, progress_pct, format } = kpi || {};

  // Get status colors or default to white
  const colors = status ? getStatusColors(status) : null;
  const bgClass = colors ? colors.bg : 'bg-white';
  const borderClass = colors ? colors.border : 'border-slate-200';
  const indicatorClass = colors ? colors.indicator : 'bg-slate-300';

  // Format the big number based on format type
  const formatBigNumber = (v) => {
    if (v == null) return '--';
    if (format === 'currency') return formatCurrency(v);
    if (format === 'percentage') return `${Math.round(v)}%`;
    return String(Math.round(v));
  };

  return (
    <button
      onClick={onClick}
      className={`w-full text-left rounded-xl p-5 border shadow-sm cursor-pointer active:scale-[0.98] transition-transform ${bgClass} ${borderClass}`}
    >
      {/* Header: status dot + label */}
      <div className="flex items-center gap-2 mb-3">
        <span className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${indicatorClass}`} />
        <span className="text-sm font-medium text-slate-600 truncate">{label || 'KPI'}</span>
      </div>

      {/* Big number */}
      <div className="text-3xl font-bold text-slate-900 mb-3">
        {formatBigNumber(value)}
      </div>

      {/* Progress bar */}
      <ProgressBarWithLabel
        value={format === 'percentage' ? (value || 0) : (value || 0)}
        max={format === 'percentage' ? (target || 100) : (target || 0)}
        format={format || 'count'}
        label={progress_pct != null ? `${Math.round(progress_pct)}%` : undefined}
      />
    </button>
  );
}
